// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-o_fY","galleryThumbnail_active":"c-o_fZ","galleryThumbnail__image":"c-o_ga"};